import { type ClassValue, clsx } from "clsx"  // Fix this import
import { twMerge } from "tailwind-merge";
export function cn(...inputs: ClassValue[]) { return twMerge(clsx(inputs)); }

